import React, { useState, useEffect } from "react";

function Popup() {
  const [showPopup, setShowPopup] = useState(false);

  // Show popup automatically when page loads
  useEffect(() => {
    setShowPopup(true);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="" >
      

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" >
          <div className="bg-white p-6 rounded-2xl shadow-lg w-96  " style={{padding:'10px',height:'100vh'}}>
            <button
              onClick={closePopup}
              className="" style={{padding:'10px',position:'absolute',right:'0',zIndex:'9999',background:'green',border:'none',color:'white'}}
            >
              Close
            </button>
            <div style={{height :'100vh',width:'900px',background:'white',overflow:'auto'}}>
                <img className="size" src="./images/popup.jpeg" style={{width:'200%'}} />
                <center><a  href="https://pages.razorpay.com/pl_Rh4SIzaj8hAD6P/view" target="blank" style={{clear:'both',border:'none',background:'maroon',color:'white',marginTop:'30px',fontSize:'15pt',padding:'15px'}}>
                Click here to pay
            </a></center>
            </div>
            

            {/* <button
              onClick={closePopup}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            >
              Close
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default Popup;
